<template>
  <div>
    <div class="landscape cockpit">
      <transition name="fade">
        <div class="cockpit-glow glowing-mobile" v-show="isMobile"></div>
      </transition>

      <transition name="fade">
        <div class="onBasses" v-show="onBasses"></div>
      </transition>
      <transition name="fade">
        <div class="onSynths" v-show="onSynths"></div>
      </transition>
      <transition name="fade">
        <div class="onBeats" v-show="onBeats"></div>
      </transition>

      <div
        class="beats"
        @mouseover="onBeats = true"
        @mouseleave="onBeats = false"
        @click="showEntry(1)"
      ></div>
      <div
        class="synths"
        @mouseover="onSynths = true"
        @mouseleave="onSynths = false"
        @click="showEntry(2)"
      ></div>
      <div
        class="basses"
        @mouseover="onBasses = true"
        @mouseleave="onBasses = false"
        @click="showEntry(3)"
      ></div>
      <Stems
        @closePopup="showEntry(0)"
        v-if="showing == 1"
        :instru="stems.beats"
      ></Stems>
      <Stems
        @closePopup="showEntry(0)"
        v-if="showing == 2"
        :instru="stems.synths"
      ></Stems>
      <Stems
        @closePopup="showEntry(0)"
        v-if="showing == 3"
        :instru="stems.basses"
      ></Stems>
      <Portal></Portal>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import Portal from "./Portal";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented";
import Stems from "@/components/utilities/Stems";
import stemsFiles from "@/components/utilities/stems-files.js";
export default {
  name: "Plantroom",
  title: "Cockpit",
  mixins: [MainMixin],
  components: {
    Portal,
    NotOriented,
    Stems,
  },
  data() {
    return {
      onBasses: false,
      onSynths: false,
      onBeats: false,
      showing: 0,
      stems: stemsFiles,
    };
  },
  methods: {
    showEntry(id) {
      this.showing = id;
      this.$store.commit("focusOnStuff");
    },
    eventClose(e) {
      if (e.key === "Escape") {
        if (this.showing !== 0) this.showEntry(0);
      }
    },
  },
  mounted() {
    this.init();
    let newMsg = {
      text:
        // "Get onboard @ kizi404.net",
        "The cockpit of the mothership.. Download our stems directly from the ship's database and remix the shit out of our tracks. (Feel free to share with the hive-mind.)",
      delay: 7000,
    };
    window.addEventListener("keyup", (e) => this.eventClose(e));
    this.$store.commit("setWanerMsg", newMsg);
  },
  destroyed() {
    window.removeEventListener("keyup", (e) => this.eventClose(e));
  },
};
</script>

<style lang="scss" scoped>
.cockpit {
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/cockpit.jpg");
  background-size: 100vw 100vh;
  background-color: black;
}

.crewroom {
  position: absolute;
  bottom: 30vh;
  height: 17vh;
  width: 7vw;
  left: 42vw;
}

.cockpit-glow {
  position: absolute;

  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/cockpit-glow.jpg");
  background-size: 100vw 100vh;
}
.onBeats {
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/cockpit_beats.jpg");
  background-size: 100vw 100vh;
}

.onSynths {
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/cockpit_synths.jpg");
  background-size: 100vw 100vh;
}

.onBasses {
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/cockpit_bass.jpg");
  background-size: 100vw 100vh;
}

.beats {
  position: absolute;
  bottom: 5vh;
  height: 30vh;
  width: 24vw;
  left: 13vw;
}
.synths {
  position: absolute;
  bottom: 38vh;
  height: 22vh;
  width: 40vw;
  left: 23vw;
}
.basses {
  position: absolute;
  bottom: 0;
  height: 26vh;
  width: 23vw;
  right: 7vw;
}
</style>
